import { render } from "./approvalsTable.vue?vue&type=template&id=5ca3865f"
import script from "./approvalsTable.vue?vue&type=script&lang=js"
export * from "./approvalsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__